import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return {
    header: {
      background: theme.palette.KenColors.CttCard,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'center',
      height: '10vh !important',
      paddingInline: '20px',
      textAlign: 'start',
      fontFamily: '"SF Pro Rounded", "Segoe UI", system-ui, -apple-system, Arial, sans-serif',
      boxShadow: 'none !important',
      marginBottom: '10px',
      [theme.breakpoints.down('md')]: {
        height: '60px !important',
      },
    },
    nav: {
      background: theme.palette.KenColors.CttCard,
      width: '100%',
      height: '100vh',
      borderRadius: '0 !important',
      minHeight: '100vh',
      boxShadow: 'none !important',
      borderRight: `1px solid ${theme.palette.KenColors.CttBorder ?? '#E5E7EB'}`,
      padding: '15px 0px',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        minHeight: '100vh',
      },
    },
    actions: {
      background: theme.palette.KenColors.CttCard,
      display: 'flex',
      height: '10vh',
      justifyContent: 'space-around',
      paddingInline: '10px',
      alignItems: 'center',
      borderRadius: '9px !important',
      boxShadow: 'none !important',
      [theme.breakpoints.down('md')]: {
        paddingInline: '5px',
      },
    },
    actionLogo: {
      height: '56px',
      width: '56px',
      objectFit: 'contain',
    },
    actionText: {
      whiteSpace: 'wrap',
      fontSize: '12px',
      fontWeight: '500 !important',
      color: theme.palette.KenColors.CttForeground,
    },
    profilImage: {
      height: '84px',
      width: '84px',
      borderRadius: '50%',
      objectFit: 'cover',
      marginBottom: '10px',
    },
    profileName: {
      fontSize: '14px !important',
      fontWeight: '600 !important',
      color: theme.palette.KenColors.CttForeground,
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '11px !important',
      },
      marginBottom: '16px !important',
    },
    profileDesignation: {
      fontSize: '12px !important',
      fontWeight: '400 !important',
      color: theme.palette.KenColors.CttMutedForeground,
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '9px !important',
      },
    },
    listItemButton: {
      borderRadius: '8px !important',
      marginLeft: '12px !important',
      marginRight: '12px !important',
      width: 'auto !important',
      paddingTop: '8px !important',
      paddingBottom: '8px !important',
      [theme.breakpoints.down('md')]: {
        marginLeft: '2px !important',
        marginRight: '2px !important',
      },
    },
    listItemButtonActive: {
      background: `linear-gradient(135deg, #4FA6E8 0%, ${theme.palette.KenColors.CttPrimary} 100%) !important`,
      borderRadius: '8px !important',
      boxShadow: `0 4px 10px 0 rgba(27, 126, 194, 0.35) !important`,
    },
    listItemIcon: {
      color: theme.palette.KenColors.CttMutedForeground,
      fontSize: '20px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '15px !important',
      },
    },
    listItemIconActive: {
      color: theme.palette.KenColors.CttCard,
      fontSize: '20px !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '15px !important',
      },
    },
    listItemText: {
      color: `${theme.palette.KenColors.CttForeground} !important`,
      fontSize: '13px !important',
      fontWeight: '500 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
      '@media (min-width: 1536px) and (max-width: 1636px)': {
        fontSize: '11px !important',
      },
    },
    listItemTextActive: {
      color: `${theme.palette.KenColors.CttCard} !important`,
      fontSize: '13px !important',
      fontWeight: '600 !important',
      '@media (min-width: 1280px) and (max-width: 1300px)': {
        fontSize: '10px !important',
      },
    },
    profilImageMobileView: {
      height: '90px',
      width: '90px',
      borderRadius: '50px',
      objectFit: 'cover',
    },
  };
});
